// import icon from "../../../../assets/images/leftMenu/basePortal/icon_gaphic.png"
let icon = "icon-portal-image_and_text"
export default {
  name: "图文列表",
  id: "",
  thumbnail: icon,
  type: "cxGaphic",
  componentType:"emptyLayoutComponent",
  // typeId: "1E4B0A24744045B7",
  typeId: "",
  children: []
}
